import React from 'react';
import PropTypes from 'prop-types';

import { StyledBoxInside } from './style';

const BoxInside = ({ className, children }) => (
  <StyledBoxInside className={className}>{children}</StyledBoxInside>
);

BoxInside.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export default BoxInside;
